export default class SupportElement {
  constructor(id, name, supportReaction) {
    this.id = id;
    this.name = name;
    this.supportReaction = supportReaction;
    this.classType="SupportElement";
  }
}
